import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const CONTROL_MEASURE_ENDPOINT = 'catalog-control-measure';
export const CONTROL_MEASURE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CONTROL_MEASURE_ENDPOINT);

export const controlMeasureStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const LISTA_CONTROL_MEASURE_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice',
    field: 'code',
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type:'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type:'text'
  },
  {
    name: 'controlMeasureType',
    label: 'Tipologia',
    field: 'controlMeasureType',
    type:'text',
    cell: ((el: any) => CONTROL_MEASURE_TYPE.find(x => x.key === el.controlMeasureType)?.value)
  },
  {
    name: 'target',
    label: 'Obiettivo',
    field: 'target',
    type:'text'
  },
  {
    name: 'reason',
    label: 'Motivazione',
    field: 'reason',
    type:'text'
  },
  {
    name: 'scopeType',
    label: 'Ambito',
    field: 'scopeType',
    type:'text'
  },
  {
    name: 'isActive',
    label: 'Attivo',
    field: 'isActive',
    type:'active'
  }
];

export const LISTA_CONTROL_MEASURE_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'description',
  'controlMeasureType',
  // 'target',
  // 'reason',
  'isActive',
  'azioni',
];

export enum ControlMeasureTypeEnum {
  INFRASTRUCTURAL = 'INFRASTRUCTURAL',
  MANAGERIAL = 'MANAGERIAL',
  CROSS = 'CROSS'
}

export const CONTROL_MEASURE_TYPE = [
  {key: "INFRASTRUCTURAL", value :"Infrastrutturale" },
  {key: "MANAGERIAL", value :"Gestionale"},
  {key: "CROSS", value :"Trasversale"}
]
